import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  variant?: 'spinner' | 'dots' | 'pulse' | 'bars';
  overlay?: boolean;
  fullScreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  message,
  variant = 'spinner',
  overlay = false,
  fullScreen = false,
}) => {
  const renderSpinner = () => {
    switch (variant) {
      case 'dots':
        return (
          <div className="loading-spinner-dots">
            <div className="loading-dot"></div>
            <div className="loading-dot"></div>
            <div className="loading-dot"></div>
          </div>
        );
      case 'pulse':
        return <div className="loading-spinner-pulse"></div>;
      case 'bars':
        return (
          <div className="loading-spinner-bars">
            <div className="loading-bar"></div>
            <div className="loading-bar"></div>
            <div className="loading-bar"></div>
            <div className="loading-bar"></div>
            <div className="loading-bar"></div>
          </div>
        );
      default:
        return (
          <div className={`loading-spinner ${size}`}>
            <div className="spinner-circle"></div>
          </div>
        );
    }
  };

  const content = (
    <div className={fullScreen ? 'loading-spinner-container loading-fullscreen' : 'loading-spinner-container'}>
      {renderSpinner()}
      {message && <p className="loading-message">{message}</p>}
    </div>
  );

  if (overlay || fullScreen) {
    return (
      <div className="loading-overlay">
        <div className="loading-overlay-content">{content}</div>
      </div>
    );
  }

  return content;
};

export default LoadingSpinner;

